import { lazy, Suspense } from 'react';

import { LoadingScreen } from '@/components/feedback/loading-screen';

const PresalesTicketStageListPage = lazy(() =>
  import('@pages/settings/accounts/presales-ticket-stages/list').then((m) => ({
    default: m.PresalesTicketStageListPage,
  }))
);

const PresalesTicketStageCreatePage = lazy(() =>
  import('@pages/settings/accounts/presales-ticket-stages/create').then((m) => ({
    default: m.PresalesTicketStageCreatePage,
  }))
);

const PresalesTicketStageEditPage = lazy(() =>
  import('@pages/settings/accounts/presales-ticket-stages/edit').then((m) => ({
    default: m.PresalesTicketStageEditPage,
  }))
);

export const presalesTicketStagesSettingsRoutes = [
  {
    path: 'presales-ticket-stages',
    children: [
      {
        element: (
          <Suspense fallback={<LoadingScreen />}>
            <PresalesTicketStageListPage />
          </Suspense>
        ),
        index: true,
      },
      {
        path: 'list',
        element: (
          <Suspense fallback={<LoadingScreen />}>
            <PresalesTicketStageListPage />
          </Suspense>
        ),
      },
      {
        path: 'new',
        element: (
          <Suspense fallback={<LoadingScreen />}>
            <PresalesTicketStageCreatePage />
          </Suspense>
        ),
      },
      {
        path: ':id/edit',
        element: (
          <Suspense fallback={<LoadingScreen />}>
            <PresalesTicketStageEditPage />
          </Suspense>
        ),
      },
    ],
  },
];
